import apiPath from '../../../config/api';

const PurchaseSalesDetailPath = {
    title: "Permata - Pembelian dan Penjualan",
    basePath: "/permata/jual-beli-detail",
    base: apiPath.retailPurchaseSalesDetail,
    purchaseSalesDetailExcel: apiPath.retailPurchaseSalesDetailExcel,
    purchaseSalesDetailFind: apiPath.retailPurchaseSalesDetailFind
}

export default PurchaseSalesDetailPath;
